import React, { useRef, useState, useEffect, useMemo } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { adminMainUrl } from "../../../../Config";

const EditGroupMaster = ({
  state_id,
  show,
  handleClose,
  onSuccess,
  token,
  user_id,
 
  refresh,
  selectedGroupMaster,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [parentOptions, setParentOptions] = useState([]);

  const dispatch = useDispatch();

  //  *   FORM VALIDATION
  const validationSchema = Yup.object({
    name: Yup.string().required("Sub Group Type is required."),
  });

  // console.log("subGroupTypeData", subGroupTypeData);


  const formik = useFormik({
    initialValues: {
      id: selectedGroupMaster?.id || "",
      name: selectedGroupMaster?.name || "",
      parent_group: selectedGroupMaster?.parent_group || "",
      group_type: selectedGroupMaster?.group_type || "",
      sub_group_type: selectedGroupMaster?.sub_group_type || "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      console.log("values", values);

      setIsSubmitting(true);
      try {
        const response = await fetch(
          `${adminMainUrl}/api/account/group-master`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "auth-token": token,
              user_id: user_id,
            },
            body: JSON.stringify(values),
          }
        );

        const data = await response.json();

        if (response.ok) {
          refresh();

          toast.success(data?.msg);
          if (onSuccess) onSuccess();
          handleClose();
        } else {
          toast.error(data?.msg);
        }
      } catch (error) {
        toast.error("Network error");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

 
  useEffect(() => {
    if (!selectedGroupMaster) return;

    formik.setFieldValue("id", selectedGroupMaster?.id);
    formik.setFieldValue("name", selectedGroupMaster?.name);
    formik.setFieldValue("parent_group", selectedGroupMaster?.parent_group);
    formik.setFieldValue("group_type", selectedGroupMaster?.group_type);
    formik.setFieldValue("sub_group_type", selectedGroupMaster?.sub_group_type);
  }, [selectedGroupMaster]);

  return (
    <Offcanvas
      className="custom-offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Group Master</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            {/* Sub Group Type Name */}
            <div className="col-12 mt-2">
              <label className="form-label">
                Group Master <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="error">{formik.errors.name}</div>
              )}
            </div>

            <div className="col-12 mt-2">
              <label className="form-label">Parent</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="parent"
                value={formik.values.parent_group}
                disabled={true}
              />
            </div>

            <div className="col-12 mt-2">
              <label className="form-label">Group Type</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="parent"
                value={formik.values.group_type}
                disabled={true}
              />
            </div>

            <div className="col-12 mt-2">
              <label className="form-label">Sub Group Type</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="parent"
                value={formik.values.sub_group_type}
                disabled={true}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="row d-flex justify-content-end mt-4">
            <div className="col-md-6 d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-sm btn-danger"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Updating...
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditGroupMaster;
